import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { examAnalysisApiSlice } from '../../../../features/curator/examAnalysisSlice'
import { tableStyles, ui } from '../../../../utils/uiTokens'
import { HeadMentor, useHeadIndex } from '../../../head/headData'

// Пән басшы: тот же экзамен по каждому ментору отдельно
const MentorRow: React.FC<{ examId: number; mentor: HeadMentor; groups: string }> = ({ examId, mentor, groups }) => {
    const { data, isFetching } = examAnalysisApiSlice.useFetchExamParticipationQuery({ examId, mentorId: mentor.mentorId })
    return (
        <TableRow sx={tableStyles.row}>
            <TableCell>
                <Box sx={{ fontWeight: 600 }}>{mentor.name}</Box>
                <Box sx={{ fontSize: '12px', color: ui.muted }}>{groups}</Box>
            </TableCell>
            <TableCell align="center">{isFetching ? '…' : `${data?.passedStudentCount ?? 0} (${data?.passedExamPercent ?? 0}%)`}</TableCell>
            <TableCell align="center">{isFetching ? '…' : data?.unPassedStudentCount ?? 0}</TableCell>
            <TableCell align="center" sx={{ fontWeight: 700, color: ui.pink }}>{isFetching ? '…' : data?.averageScore ?? 0}</TableCell>
        </TableRow>
    )
}

const MentorExamComparison: React.FC<{ examId: number }> = ({ examId }) => {
    const { formatMessage } = useIntl()
    const index = useHeadIndex()
    if (!examId || !index.mentors.length) return null
    return (
        <Box sx={{ margin: '18px 0' }}>
            <Box sx={{ fontWeight: 700, fontSize: '15px', marginBottom: '10px' }}>{formatMessage({ id: 'headMentorCompare' })}</Box>
            <TableContainer component={Paper} sx={tableStyles.container} elevation={0}>
                <Table size="small">
                    <TableHead sx={tableStyles.head}>
                        <TableRow>
                            <TableCell>{formatMessage({ id: 'colMentor' })}</TableCell>
                            <TableCell align="center">{formatMessage({ id: 'passed' })}</TableCell>
                            <TableCell align="center">{formatMessage({ id: 'unpassed' })}</TableCell>
                            <TableCell align="center">{formatMessage({ id: 'averagePoint' })}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {index.mentors.map((m) => (
                            <MentorRow
                                key={m.mentorId}
                                examId={examId}
                                mentor={m}
                                groups={m.groupIds.map((id) => index.groupTitle.get(id)).filter(Boolean).join(', ')}
                            />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default MentorExamComparison
